import styled from 'styled-components';

export default styled.div`
  // display: none; /* Hide modal by default */
  width: 588px;
  position: fixed; /* Position the modal relative to the viewport */
  top: 50%; /* Center the modal vertically */
  left: 50%; /* Center the modal horizontally */
  transform: translate(-50%, -50%); /* Center the modal perfectly */
  background-color: white; /* Background color of the modal */
  padding: 48px 40px 32px; /* Add some padding */
  border-radius: 5px; /* Rounded corners */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); /* Add a shadow effect */
  z-index: 1000;
  .auth-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .modal-close {
    &:before {
      content: url("/assets/img/close.svg");
      float: right;
      cursor: pointer;
    }
  }
  .info {
    margin-bottom: 24px;
  }
  a {
    color: var(--coral);
    cursor: pointer;
  }
`;
